export class GA4 {
    listId;
    listName;
    taxApplier;
    enabled;
    constructor(listId, listName, taxApplier, enabled = true) {
        this.listId = listId;
        this.listName = listName;
        this.taxApplier = taxApplier;
        this.enabled = enabled;
    }
    convertProductIntoItem(p, variation, index = 0, quantity = 1) {
        const item = {
            index: index,
            item_list_id: this.listId,
            item_list_name: this.listName,
            quantity: quantity,
        };
        let sku = p.sku;
        let name = p.name;
        let price = p.price;
        let basePrice = p.basePrice;
        let taxClass = p.taxClass;
        if (p.type === "variable") {
            if (p.catalogData?.variations &&
                p.catalogData.variations.products.length > 0) {
                let v = p.catalogData.variations.products[0];
                if (variation) {
                    v = p.catalogData.variations.products.find((v) => v.id.toString() === variation);
                }
                sku = v.sku;
                name = v.name;
                price = v.price;
                basePrice = v.basePrice;
                taxClass = v.taxClass;
                item["item_variant"] = v.attributeTerm;
            }
        }
        basePrice = this.taxApplier(basePrice, taxClass);
        price = this.taxApplier(price, taxClass);
        item["item_id"] = sku;
        item["item_name"] = name;
        item["price"] = basePrice;
        item["discount"] = basePrice - price;
        item["curr_price"] = price;
        let cat = p.taxonomies["product_cat"]?.[0];
        let i = 1;
        while (cat) {
            if (i === 1) {
                item["item_category"] = cat.name;
            }
            else if (i < 6) {
                item[`item_category${i}`] = cat.name;
            }
            else {
                break;
            }
            cat = cat.children[0];
            i++;
        }
        let gender = p.taxonomies["product_gender"]?.[0];
        if (gender && i < 6) {
            item[`item_category${i}`] = gender.name;
        }
        let brand = p.taxonomies["product_brand"]?.[0] ??
            p.taxonomies["brand_taxonomy"]?.[0];
        if (brand) {
            item["item_brand"] = brand.name;
        }
        return item;
    }
    dataLayerPush(event, data) {
        // console.log({ event, data });
        if (!this.enabled) {
            return;
        }
        try {
            if (typeof dataLayer !== "object") {
                return;
            }
            data.event = event;
            dataLayer.push({ ecommerce: null });
            dataLayer.push(data);
        }
        catch (e) {
            console.error(e);
        }
    }
    viewItemList(prods) {
        this.dataLayerPush("view_item_list", {
            ecommerce: {
                items: prods.map((p) => this.convertProductIntoItem(p.p, p.v, p.idx)),
            },
        });
    }
    selectItem(p, v, idx = 0) {
        this.dataLayerPush("select_item", {
            ecommerce: {
                items: [this.convertProductIntoItem(p, v, idx)],
            },
        });
    }
    addToCart(p, v, idx = 0, qty = 1) {
        const item = this.convertProductIntoItem(p, v, idx, qty);
        this.dataLayerPush("add_to_cart", {
            currency: "EUR",
            value: item["curr_price"] ?? 0,
            ecommerce: {
                items: [item],
            },
        });
    }
    addToWishlist(p, v, idx = 0) {
        const item = this.convertProductIntoItem(p, v, idx);
        this.dataLayerPush("add_to_wishlist", {
            currency: "EUR",
            value: item["curr_price"] ?? 0,
            ecommerce: {
                items: [item],
            },
        });
    }
}
